// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.skeleton[data-v-264f373a]{background:#f1f2f6;width:100%;height:100%;border-radius:11px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
